/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/
import React, { PureComponent } from "react";
import clsx from "clsx";
import Image from "../Image";
import Icon from "../Icons";
import Button from "../Button";
import RedirectSite from "../Redeem_Bank";
import { interaction, getError } from "../../service";
import MerchantInfo from "../Merchant_Info";
import { formatDateDDMMMYYYY, formatDateArabicDDMYYYY } from "../../pages/helper";
import { offerItemHeader } from "../../constants";
import uiConfig from "../../uiConfig";
import RedeemBankOfferCard from "../Redeem_Bank_Offer_Card";
import {arabicContent} from "../../constants/index";
import config from "../../service/config";
const lang = localStorage.getItem("language");
//Import Config
var MatomoTracker = require('matomo-tracker');
var matomo = new MatomoTracker(config.siteId, config.siteURL);
export default class bankBestOffer extends PureComponent {
  state = {
    isVisibleOfferInfo: false,
    activeMenu: "offerDetails",
    isModalOpen: false,
    width: 0,
    claimStatus : this.props.item.claimed,
    isExpand: false
  };
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if(localStorage.getItem("openClaimModal") && localStorage.getItem("openClaimModal") === "true"){
      this.setState({isModalOpen: true});
    }
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
  /* OnClick Function */
  _onChangeTab = (id) => {
    this.setState({ activeMenu: id });
  };
  _onClose = () => {
    localStorage.setItem("openClaimModal","false")
    localStorage.removeItem("offerDetail")
    localStorage.removeItem("merchantDetail")
    this.setState({ isModalOpen: false });
    document.documentElement.style.overflowY='auto'
    document.body.style.overflowY = 'auto';
  };
  _onClick = (itemId) => {
    const { item,merchantId,from } = this.props;
    const { claimStatus } = this.state;
    if (localStorage.getItem("USERID")===null) {
      this.props._openLogin();
      localStorage.setItem("interactionType","CLAIM");
      localStorage.setItem("interactionId",itemId);
      localStorage.setItem("interactionFrom","Merchant");
      localStorage.setItem("offerDetail", JSON.stringify(this.props.item))
      localStorage.setItem("merchantDetail",JSON.stringify({
        "merchantName":this.props.merchantName,
        "merchantItem":this.props.merchantItem,
        "baseURL":this.props.baseURL
      }))
    }
    if (localStorage.getItem("USERID")) {
      this.setState({ isModalOpen: true });
      document.documentElement.style.overflowY='hidden'
      document.body.style.overflowY = 'hidden';
      // if(!claimStatus){
      //   this.setState({ claimStatus : !claimStatus });
      //   matomo.track({
      //     url: window.location.href,
      //     e_c: merchantId,
      //     e_a: 'CLAIM',
      //     e_n: item.id,
      //   });
      //   interaction("CLAIM", "OFFER",itemId)
      //     .then((res) => {
      //       // this.setState({ claimStatus : !claimStatus });
      //   //    this.setState({ isModalOpen: true });
      //     })
      //     .catch((err) => {
      //       if (err && err.data&&err.data.status === 404) {
      //       } else {
      //     //    console.log(getError(err));
      //       }
      //     });
      //   }
    }
  
  };
  onRedeemInteraction =()=>{
    const { item, merchantId } = this.props;
    matomo.track({
        url: window.location.href,
        e_c: merchantId,
        e_a: 'APPLY NOW',
        e_n: item.id,
      });
  }
  _onClickItem = () => {
    const { isVisibleOfferInfo } = this.state;
    this.setState({ isVisibleOfferInfo: !isVisibleOfferInfo });
  };
  toggleExpandCard =() =>{
    this.setState({isExpand:true})
  }  
  /* Other Render Functions */
  _renderTitle(title, id) {
    const { activeMenu } = this.state;
    const cls = {
      nav: true,
      "nav-act": id === activeMenu
    };
    return (
      <div className={`${clsx(cls)} p-0 ${lang === 'AR' ? "nav-ar" : ""}`}  onClick={() => this._onChangeTab(id)}
      style={(config.clientName === "HDFC") ?id===activeMenu?{marginRight:"32px",fontWeight:"bold",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.color,borderBottom:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.borderBottom}:{marginRight:"32px",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenu.color} : 
          id===activeMenu?{fontWeight:"bold",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.color,borderBottom:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.borderBottom}:{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenu.color}}
      >
        {(title)?title.toUpperCase():''}
      </div>
    );
  }
  /* Other Render Functions */
  _renderMobileView() {
    const { isVisibleOfferInfo, claimStatus,activeMenu } = this.state;
    const { item, itemUrl,isActiveOffer } = this.props;
    let claimedTxt = lang === "AR" ? arabicContent.claimed : "Offer Availed";
    let claimTxt = lang === "AR" ? arabicContent.claim : "Claim now";
    let onlineTxt = lang === "AR" ? arabicContent.online : "Online Offer";
    let instoreTxt = lang === "AR" ? arabicContent.instore : "Instore";
    const minWidth = 768;
    if (minWidth >= this.state.width) {
      return (
        <div className="col-md-12 p-0 best_offer">
          <div className="col-md-12 p-0  _ai-c">
            <div className={`col-md-2 p-0`}>
              {/* {item.image && <Image src={item.image.replace(/ /g, "%20")} w={60} h={60} />} */}
              {/* <Image src={item.image.replace(/ /g, "%20")} w={60} h={60} /> */}
            </div>
            <div className="col-md-10 p-0">
              <div className="heading-best-offer mbl" style={{color:uiConfig.config?.whitelabel?.merchant_details?.offer_cards.offerCardTitleColor}}>
                <span className="offer-desc mbl">{item.name}</span>
                {/* <span className={`toggle flex-center ${lang === 'AR' ? "mr-8" : "ml-8"}`} onClick={this._onClickItem}>
                  <Icon
                  fill="#000"
                  width={14}
                  height={14}
                  name={isVisibleOfferInfo ? "arrowUp" : "arrowDown"}
                />
                </span> */}
              </div>
              
              {/* <div className="desc-best-offer mbl">
                Online Exclusive - New lines added daily
              </div> */}
            </div>
          </div>
          {/* <div className={isVisibleOfferInfo?"card-show":"card-hide"}> */}
          <div>
            <div className={`p-0 header-item header-item-bank ${lang === 'AR' ? "col-md-12" : "col-md-9"}`}>
            {this._renderTitle(lang === 'AR' ? arabicContent.features : "Features", "offerDetails")}
            {this._renderTitle(lang === 'AR' ? arabicContent.eligibility : "Eligibility", "redeem")}
            {this._renderTitle(
              lang === 'AR' ? arabicContent.feesAndCharges : "Fees & Charges",
              "termsAndCondition"
            )}
            {item.location
            &&this._renderTitle(
              lang === 'AR' ? arabicContent.merchantAndStores : offerItemHeader.merchantAndStores,
              "merchantAndStores"
            )}
          </div> 
          {activeMenu!=="merchantAndStores"?  
          <div className={`col-md-12 p-0 item-det-info ${lang === 'AR' ? "item-det-info-ar" : ""}`}>
            {this._renderDescription()}
            {this._renderRedeem()}
            {this._renderTermsAndCondition()}
           
          </div>:item.location&&
          <div> <MerchantInfo item={item} /></div>
        }
        </div>
        <div className={"col-md-12 p-0 mt-10 _ai_baseline"}>
            <div className="flex-start">
              <div className="info-offer flex-center mbl" style={{ color: uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor }}>
                {/* {lang === "AR" ? formatDateArabicDDMYYYY(item.validTo) : formatDateDDMMMYYYY(item.validTo)} |{" "} */}
                {item.isOnline ? onlineTxt : instoreTxt}
              </div>
            </div>
            {
              !item?.isExpired ?
                <div className="flex-end btn-div">
                  <Button
                    variant={claimStatus ? "success" : "primary"}
                    size="md"
                    label={claimStatus ? "Click here" : "Click here"}
                    onClick={() => this._onClick(item.id)}
                  />
                </div>
                :
                <div className="expire-div flex">
                  <div>Oops!</div>
                  <div className="oops-div" ></div>
                  <div>This offer has expired.
                    Do check out other exciting offers!</div>
                </div>
            }
          </div>
        </div>
      );
    }
    return null;
  }
  _renderNormalView() {
    const { claimStatus,activeMenu } = this.state;
    const { item,isActiveOffer, itemUrl ,from} = this.props;
  
    const minWidth = 768;
    let {isExpand} = this.state;
   // console.log(this.props)
    if (minWidth < this.state.width) {
      return (
        <>
        <div className={`col-md-12 p-0 ${lang === 'AR' ? "flex" : ""}`}>
          <div className={`col-md-9 p-100 ${lang === 'AR' ? "p-100-ar" : ""}`}>
            <div className="best-offer-header" style={{ color: uiConfig.config?.whitelabel?.merchant_details?.offer_cards.offerCardTitleColor }}>{item.name}</div>
            {<div className="info-offer" style={{ color: uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor }}>
              {lang === 'AR' ? arabicContent.offerInfo1 :
                <span>All you need to know.</span>}
            </div>}
            <div className={`p-0 header-item ${lang === 'AR' ? "col-md-12" : "col-md-9"}`}>
              {this._renderTitle(lang === 'AR' ? arabicContent.features : "Features", "offerDetails")}
              {this._renderTitle(lang === 'AR' ? arabicContent.eligibility : "Eligibility", "redeem")}
              {this._renderTitle(
                lang === 'AR' ? arabicContent.feesAndCharges : "Fees & Charges",
                "termsAndCondition"
              )}
              {item.location
                && this._renderTitle(
                  lang === 'AR' ? arabicContent.merchantAndStores : offerItemHeader.merchantAndStores,
                  "merchantAndStores"
                )}
            </div>
            
            {/* {config.clientName === "HDFC" && itemUrl&&<div className="info-offer" style={{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor}}>
                {lang === 'AR' ? arabicContent.offerInfo1 : `This offer is available to ${config.clientName} Cards. To redeem this offer, visit `}
                <span style={{color:uiConfig.config.whitelabel.urlColor}} className="redeem-url ellipsis" onClick={()=> {this.props.onClick()}}>{itemUrl}</span> {!item.redemptionCode ? <span></span> : <span>
                {lang === 'AR' ? arabicContent.offerInfo2 : `, please enter promo code while at checkout`}</span>} 
            </div>} */}
            {/* {!isExpand &&<div className="text-expand" style={{ color: !item?.isExpired ? "#005AB7" : "#E30613" }} onClick={()=>this.toggleExpandCard()} >
              {lang === 'AR' ? arabicContent.expandTxt : `Expand for Details`}
            </div>} */}
              </div>
            <div className="col-md-3 p-0">
            <RedeemBankOfferCard itemUrl={itemUrl} item={item} claimStatus={claimStatus} _onClick={this._onClick} from={from} />            </div>
          </div>
          <div>
            {activeMenu !== "merchantAndStores" ?
              <div style={{ color: uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardDescriptionTextColor }}
                className={`col-md-12 p-0 item-det-info ${lang === 'AR' ? "item-det-info-ar" : ""}`}>
                {this._renderDescription()}
                {this._renderRedeem()}
                {this._renderTermsAndCondition()}
              </div> : item.location &&
              <div> <MerchantInfo item={item} /></div>
            }
          </div>
        </>
      );
    }
    return null;
  }
  _renderDescription() {
    const { item } = this.props;
    const { activeMenu } = this.state;
    if (activeMenu !== "offerDetails") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.description }} />
      );
    }
    // if (lang === "AR"){
    //   return arabicContent.description;
    // }
  }
  _renderMerchantAndStores() {
    const { item } = this.props;
    const { activeMenu } = this.state;
    if (activeMenu !== "offerDetails") return null;
    return <MerchantInfo item={item} />
  }
  _renderRedeem() {
    const { item } = this.props;
    const { activeMenu } = this.state;
    if (activeMenu !== "redeem") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.howToRedeem }} />
      );
    }
    // if (lang === "AR"){
    //   return arabicContent.howToRedeem;
    // }
  }
  _renderTermsAndCondition() {
    const { item } = this.props;
    const { activeMenu } = this.state;

    if (activeMenu !== "termsAndCondition") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.termsAndConditions }} />
      );
    }

    //if (activeMenu !== "termsAndCondition") return null;
    // if (lang === "AR"){
    //   return arabicContent.termsAndConditions;
    // }
    //return item.termsAndConditions;
  }
  /* Render Functions */
  render() {
    var { isModalOpen,activeMenu } = this.state;
    const { item, baseURL ,merchantName,merchantItem, from } = this.props;
    const offerItem = localStorage.getItem("offerDetail")? JSON.parse(localStorage.getItem("offerDetail")):null
    const lmerchantName = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).merchantName:null
    const lmerchantItem = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).merchantItem:null
    const lbaseURL = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).baseURL:null
  //  console.log(merchantName)
    return (
      <>
        {this._renderNormalView()}
        {this._renderMobileView()}
        {
          isModalOpen && 
          <RedirectSite
            hide={this._onClose}
            item={offerItem? offerItem:item}
                    baseURL={lbaseURL ? lbaseURL : baseURL}
                    onRedeemInteraction={this.onRedeemInteraction}
          />
        }
        
        {/* {
          isModalOpen && 
          <DemoModal
            size="small"
            redeem={true}
            isModalOpen={isModalOpen}
            hide={this._onClose}
            item={offerItem? offerItem:item}
            baseURL={lbaseURL? lbaseURL:baseURL}
            onRedeemInteraction={this.onRedeemInteraction}
            merchantName={lmerchantName? lmerchantName:merchantName} 
            merchantItem={lmerchantItem? lmerchantItem:merchantItem} 
          />
        } */}
      </>
    );
  }
}